import { render, staticRenderFns } from "./GiteaImgStorageModal.vue?vue&type=template&id=1ad8b635&"
import script from "./GiteaImgStorageModal.vue?vue&type=script&lang=js&"
export * from "./GiteaImgStorageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteaImgStorageModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteaImgStorageModal.vue
// module id = 2354
// module chunks = 1